import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Header/Header';
import AppRoutes from './AppRoutes';
import Footer from '../Footer/Footer';
import { AuthProvider } from '../../utils/AuthContext';

import '../../styles/main.scss';

const App = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <div className={`App${isAdminRoute ? ' App--admin' : ''}`}>
      {!isAdminRoute && <Header />}
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
      {!isAdminRoute && <Footer />}
    </div>
  );
};

export default App;
